import React from 'react';

import { Switch, FormControlLabel, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import formEngineStyle from 'theme/formEngine-theme';

const RenderSwitchForm = ({ input, label, checked, className, disabled, meta, classes }) => (
  <FormControlLabel
    classes={{ label: className }}
    className={className}
    control={
      <Switch
        checked={checked !== undefined ? checked : Boolean(input.value)}
        onChange={(event, isChecked) => input.onChange(isChecked)}
        color="secondary"
        disabled={disabled}
        classes={{
          switchBase: classes.switchBase,
          icon: classes.switchIcon,
          checked: classes.switchChecked,
          disabled: classes.switchDisabled,
          track: classes.track,
        }}
      />
    }
    label={<Typography variant="body">{label || meta?.error}</Typography>}
  />
);

RenderSwitchForm.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string,
  meta: PropTypes.object,
  classes: PropTypes.object,
};

export default withStyles(formEngineStyle)(RenderSwitchForm);
